import { Group, Mesh } from 'three/webgpu'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'

/** Original Sea Cruise icebreaker. Metres, Y-up, +Z bow, amidships waterline origin.
 * Playable vessel physics are configured in Tug.ts for the icebreaker kind.
 */
export async function loadIcebreakerModel(): Promise<Group> {
  const { scene } = await new GLTFLoader().loadAsync('/models/icebreaker/icebreaker.glb')
  const vessel = new Group()
  vessel.name = 'icebreaker-sea-cruise'
  scene.rotation.y = -Math.PI / 2 // native glTF +X bow -> Hawser +Z bow
  vessel.add(scene)
  vessel.traverse((object) => {
    if (!(object as Mesh).isMesh) return
    object.castShadow = true
    object.receiveShadow = true
  })
  return vessel
}
